import {
  DEMAND_REQUEST_OVERLAY,
  LOGIN_OVERLAY,
  PORTAL_NEWS_OVERLAY,
  PROFILE_DELETE_REQUEST_CODE_OVERLAY,
  PROJECT_TEAM_INVITATION_LIST_OVERLAY
} from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useLoginWithIDP } from "shared/lib/useLoginWithIDP"
import { useOpenCookieBanner } from "shared/lib/useOpenCookieBanner"
import { useOverlay } from "shared/lib/useOverlay"
import { AppActionType } from "shared/types/AppAction"

export function useAppAction() {
  const openCookieBanner = useOpenCookieBanner({})
  const { loginAsVisitor } = useLoginWithIDP()
  const { openOverlay: openContactOverlay } = useOverlay(DEMAND_REQUEST_OVERLAY)
  const { openOverlay: openPortalNewsOverlay } = useOverlay(PORTAL_NEWS_OVERLAY)
  const { openOverlay: openProjectTeamInvitationsOverlay } = useOverlay(
    PROJECT_TEAM_INVITATION_LIST_OVERLAY
  )
  const { openOverlay: openProfileDeleteOverlay } = useOverlay(
    PROFILE_DELETE_REQUEST_CODE_OVERLAY
  )
  const { openOverlay: openLoginOverlay } = useOverlay(LOGIN_OVERLAY)

  return useEvent((action: AppActionType) => {
    switch (action) {
      case AppActionType.CONTACT:
        openContactOverlay(null)
        break
      case AppActionType.PORTAL_NEWS:
        openPortalNewsOverlay(null)
        break
      case AppActionType.PROJECT_TEAM_INVITATIONS:
        openProjectTeamInvitationsOverlay(null)
        break
      case AppActionType.OPEN_COOKIE_BANNER:
        openCookieBanner()
        break
      case AppActionType.DELETE_PROFILE:
        openProfileDeleteOverlay(null)
        break
      case AppActionType.VISITOR_LOGIN:
        loginAsVisitor?.()
        break
      case AppActionType.LOGIN:
        openLoginOverlay(null)
        break
      default:
    }
  })
}
